// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__33s44","title":"ClientInsurance_title__3YqIp","itemText":"ClientInsurance_itemText__1qpCm"};